export const formatFirestoreError = (
  file: string,
  method: string,
  error: unknown
) => `Firestore error on '${file} - ${method}': ${error}`;
